import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import wishlistReducer from './wishlistSlice';
import orderReducer from './orderSlice';
import productReducer from './productSlice';
import collectionReducer from './collectionSlice';
import authReducer from './authSlice'; // Import the authSlice
import siteConfigReducer from './siteConfigSlice'; // Import the authSlice

const store = configureStore({
  reducer: {
    cart: cartReducer,
    wishList: wishlistReducer,
    order: orderReducer,
    products: productReducer,
    collections: collectionReducer,
    auth: authReducer,
    siteConfig: siteConfigReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
